@if (control) {
  <fieldset [attr.id]=" question.id ">
    <legend>
      <div [attr.aria-labelledby]=" question.id + '-err'"></div>
    </legend>
    <div id="{{ question.id }}-desc" [innerHTML]="messages.getText('WILL.text.' + question.id)"></div>
    <div class="mb-6">
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">{{ messages.getText('search.placeholder') }}</span>
        <input id="charity-search" type="text" class="form-control"
               [formControl]="charitySearchControl!"
               [placeholder]="messages.getText('label.find-your-charity')"
               [attr.aria-label]="messages.getText('label.find-your-charity')">
      </div>
      @if (controlHasError()) {
        <div class="alert  alert-danger error pill form-error-list">
          <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
            <ul>
              @for (err of baseForm.errorMap.get(question.id!); track err) {
                <li>
                  <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
                </li>
              }
            </ul>
          </div>
        </div>
      }
      <div [ngClass]="inputClass" class="container px-0">
        @for (option of selectedCharities; track option.nonProfitId) {
          <div class="option-row left row align-items-center selected">

            <label class="option " for="{{ question.id }}-{{ option.nonProfitId }}">
              <div class="simple-option-content">{{ option.name }}</div>
              <input #input type="checkbox"
                     [attr.name]="question.id + '-' + option.nonProfitId"
                     name="{{ question.id }}-{{ option.nonProfitId }}"
                     id="{{ question.id }}-{{ option.nonProfitId }}"
                     [value]="option.name"
                     [attr.aria-invalid]="controlHasError()"
                     (keydown.enter)="onEnter($event)"
                     (change)="removeSelectedCharity(option);revalidateInput()"
                     [attr.aria-label]="getLabel()"
                     checked/>
              <span class="checkmark"></span>
            </label>
          </div>
        }
        @if (selectedCharities!.length > 0) {
          <hr>
        }
        @for (option of charities; track option) {
          <div class="option-row left row align-items-center">

            <label class="option " for="{{ question.id }}-{{ option.nonProfitId }}">
              <div class="simple-option-content">{{ option.name }}</div>
              <input #input type="checkbox"
                     [attr.name]="question.id + '-' + option.nonProfitId"
                     name="{{ question.id }}-{{ option.nonProfitId }}"
                     id="{{ question.id }}-{{ option.nonProfitId }}"
                     [value]="option.name"
                     [attr.aria-invalid]="controlHasError()"
                     (keydown.enter)="onEnter($event)"
                     (change)="selectCharity(option);revalidateInput()"
                     [attr.aria-label]="getLabel()"/>
              <span class="checkmark"></span>
            </label>

            @if ($last && baseForm.isSubmitted(form) && control.touched) {
              <div #feedback class="feedback-icon form-group radio" aria-hidden="true">
                <i class="fa" aria-hidden="true"
                   [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle' : controlHasError() }"></i>
              </div>
            }

          </div>
        }
      </div>
    </div>

    @if (findChangedMindQuestion()) {
      <div id="changed-mind my-4">
        <checkbox-control #changedMindControl
                          [baseForm]="baseForm"
                          [form]="this.form"
                          [id]="changedMind!.id! + '-wrapper'"
                          [questionId]="changedMind!.id!"
                          [question]="changedMind!"
                          [standalone]="false"
                          [onEnter]="onEnter">
        </checkbox-control>
      </div>
    }
    <div class="option-row mt-6 mx-0">
      <div class="px-0 text-end">
        <button class="btn primary rounded-pill confirm-button"
                [attr.aria-label]="getLabel() + '.confirm_button'"
                (click)="onEnter($event)"
                (keydown.enter)="onEnter($event)">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ messages.getText('WILL.button.save-and-continue') }}
        </button>
      </div>
    </div>
  </fieldset>
}
<ng-content></ng-content>
